import { useEffect, useState } from "react";
import axios, { API } from "@/lib/api";
import { Phone, GraduationCap, Briefcase } from "lucide-react";
import LoadingScreen from "@/components/shared/LoadingScreen";

export default function Pembimbing() {
  const [guides, setGuides] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/guides`).then(({ data }) => setGuides(data)).catch(() => setGuides([]));
  }, []);

  if (guides === null) return <LoadingScreen />;

  return (
    <div data-testid="pembimbing-page">
      <section className="bg-gradient-to-br from-[#084C3A] to-[#0B4F71] px-4 py-16 text-center sm:px-6">
        <h1 className="font-heading text-3xl font-bold text-white sm:text-4xl">Tim Pembimbing Kami</h1>
        <p className="mt-3 text-white/80">Dibimbing oleh para ustaz dan ustazah yang berpengalaman dan bersertifikat.</p>
      </section>

      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {guides.map((g) => (
            <div key={g.id} data-testid={`pembimbing-card-${g.id}`} className="rounded-3xl bg-white p-7 shadow-[0_2px_16px_rgba(15,107,79,0.06)]">
              <img src={g.photo_url} alt={g.name} className="mx-auto h-28 w-28 rounded-full object-cover ring-4 ring-[#0F6B4F]/10" />
              <h3 className="mt-4 text-center font-heading text-lg font-semibold text-[#1F2937]">{g.name}</h3>
              <p className="text-center text-sm text-[#1677B8]">{g.position}</p>
              <p className="mt-4 text-sm leading-relaxed text-[#64748B]">{g.bio}</p>
              <div className="mt-4 space-y-2 text-sm text-[#1F2937]">
                <p className="flex items-center gap-2"><GraduationCap className="h-4 w-4 text-[#0F6B4F]" /> {g.education}</p>
                <p className="flex items-center gap-2"><Briefcase className="h-4 w-4 text-[#0F6B4F]" /> {g.experience}</p>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {(g.expertise || []).map((e) => (
                  <span key={e} className="rounded-full bg-[#F5F9F7] px-3 py-1 text-xs text-[#0F6B4F]">{e}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
